exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".body.home h1{color:#fff}.system-admin{display:flex;flex-direction:row}.system-admin .inner-body{flex:1 0 auto;padding:30px}.body-sidebar{display:flex;flex-direction:column;width:250px;height:100%;background:#f2f2f2;min-height:calc(100vh - 60px - 30px)}.body-sidebar a{width:100%;display:block;padding:15px;font-size:14px;text-decoration:none;color:inherit;border-bottom:1px solid #e5e5e5;border-top:1px solid #fff}.body-sidebar a.active{background:#fff;cursor:default}.body-sidebar a.active:hover{background:#fff}.body-sidebar a:hover{background:#fafafa}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/SystemAdmin/SystemAdmin.scss
// module id = 908
// module chunks = 0